export const JaLocale = {
    page: {
        txtTitle: 'UNVOX | ボーカルを即時に除去',
    },
    global: {
        brand: {
            txtName: 'unvox.ai',
            txtLogoAlt: 'unvox ロゴ',
        },
        action: {
            txtBack: '戻る',
            txtRetry: '再試行',
            txtStartOver: '最初からやり直す',
        },
        job: {
            txtCheckingStatus: 'ジョブの状態を確認中',
            txtIdLabel: 'ジョブ ID',
        },
        footer: {
            linkPrivacyPolicy: 'プライバシーポリシー',
            linkTerms: '利用規約',
            linkRefunds: '返金',
            linkSupport: 'サポート',
            txtAllRightsReserved: 'All Rights Reserved.',
            txtBugReportsAndFeatures: 'バグ報告と機能リクエスト',
        },
        share: {
            title: 'UNVOX | ワンクリックで楽曲のボーカル除去',
            text: 'お気に入りの曲を簡単にカラオケ向けインストに変換できます！',
        },
    },
    route: {
        home: {
            txtHeroKicker: '',
            txtHeroTitle: 'ワンクリックでボーカル除去',
            txtHeroSubtitle: 'あなたのトラックまたは YouTube からすぐにインストを生成',
            txtInputTypeLabel: '入力タイプ',
            txtInputTypeFile: '音声ファイルをアップロード',
            txtInputTypeYoutube: 'YouTube リンク',
            txtInputFilePick: 'ファイルを選択',
            txtInputFileSub: '一般的な音声形式 ({{formats}})、最大 {{size}} MB。',
            txtPreviewAction: 'ボーカルを除去',
            txtPreviewFailed: '不明なエラーが発生しました。しばらくしてから再度お試しください。',
            txtUploadSelectFile: 'まだファイルが選択されていません',
            txtYoutubeLabel: 'YouTube URL',
            txtYoutubePlaceholder: 'https://youtube.com/watch?v=...',
            txtYoutubeHelper: '公開されている YouTube リンクを貼り付けてください。',
            txtYoutubeMissing: 'YouTube URL を貼り付けてください。',
            txtYoutubeInvalid: '有効な YouTube URL を入力してください。',
            txtYoutubeTooLong: 'この動画は 15 分を超えています。より短い動画を選択してください。',
            txtCheckoutUploadFailed: 'アップロードに失敗しました。もう一度お試しください。',
            txtUploadMissing: 'アップロード前にファイルを選択してください。',
            txtFileTypeInvalid: '未対応のファイル形式です。音声ファイルをアップロードしてください（例: {{formats}}）。',
            txtFileTooLarge: 'ファイルが大きすぎます。最大サイズは {{size}} MB です。',
        },
        previewJob: {
            txtUnavailableTitle: 'プレビューを作成できませんでした',
            txtUnavailableBody: '不明なエラーが発生しました。しばらくしてから再度お試しください。',
            txtPreparingTitle: 'プレビューを準備中',
            txtPreparingBody: '最大 2 分かかる場合があります',
        },
        payment: {
            txtUnavailableTitle: 'プレビューを作成できませんでした',
            txtUnavailableBody: '不明なエラーが発生しました。しばらくしてから再度お試しください。',
            txtPreparingTitle: 'プレビューを準備中',
            txtCheckoutCancelledBody: '課金は行われませんでした。いつでも再試行できます。',
            txtTrackPreviewLabel: 'トラックプレビュー',
            txtTrackPreviewHelper: 'このプレビューは評価用の 15 秒クリップです',
            txtEmailLabel: 'メールアドレス',
            txtEmailPlaceholder: 'yourname@email.com',
            txtEmailCheckoutHelper: 'ダウンロードリンクの送信に使用します。',
            txtCheckoutAction: '{{price}} でボーカルを除去',
            txtCheckoutActionFallback: 'ボーカルを除去',
            txtCheckoutFailed: 'チェックアウトを開始できませんでした。もう一度お試しください。',
            txtInvalidEmail: '有効なメールアドレスを入力してください。',
        },
        processing: {
            txtMissingTitle: 'ジョブ id がありません',
            txtMissingBody: 'このページにはジョブ id が必要です。新しいプレビューを開始してください。',
            txtMissingAction: 'アップロードへ戻る',
            txtStatusFailed: 'ジョブ状態を取得できませんでした。もう一度お試しください。',
            txtErrorTitle: '問題が発生しました',
            txtSupportAction: 'サポートに連絡',
            txtConfirmingTitle: '支払いを確認中',
            txtConfirmingBody: 'Confirming payment status',
            txtPolling: '更新を確認中',
            txtWorkingTitle: 'フルトラックを処理中',
            txtWorkingBody: 'This will take a few minutes. You will receive an email when the track is ready.',
            txtWorkingAction: '別の曲を開始',
            txtReadyTitle: 'ダウンロード準備完了',
            txtReadyBody: 'インスト音源のダウンロード準備ができました。',
            txtDownloadAction: 'ダウンロード',
            txtDownloadNote: 'This download link expires in 72 hours and will be emailed to you.',
            txtReadyAction: '別の曲を開始',
        },
        invalidJob: {
            txtTitle: '無効なジョブ id',
            txtBody: 'そのジョブは見つかりませんでした。新しいアップロードを開始してください。',
            txtAction: '最初からやり直す',
        },
        refund: {
            txtEyebrow: 'Legal',
            txtTitle: 'Refund Policy',
            txtLastUpdatedLabel: 'Last updated',
            txtLastUpdatedDate: 'February 17, 2026',
            txtIntro: 'All purchases are final. We do not issue refunds.',
            txtSectionServiceErrorsTitle: 'Service Errors and Reprocessing',
            txtSectionServiceErrorsBody: 'We want our users to be satisfied with the Service. If an error occurs on our side, we will reprocess your files at no additional cost.',
            txtServiceErrorsItemJobFailed: 'If a job fails due to a technical issue in the Service, we will rerun it.',
            txtServiceErrorsItemDeliveryFailed: 'If output delivery fails due to our systems, we will redeliver your results.',
            txtSectionHelpTitle: 'How to Request Help',
            txtSectionHelpBody: 'Contact Support and include your job ID and the email address you used at checkout. We may ask for additional details to diagnose and reprocess your job.',
            txtNoRefundsNote: 'No refunds will be issued.',
        },
        support: {
            txtEyebrow: 'サポート',
            txtTitle: 'サポートに連絡',
            txtLastUpdatedLabel: '最終更新',
            txtLastUpdatedDate: '2026年2月9日',
            txtSectionEmailTitle: 'メール',
            txtSectionEmailBodyPrefix: 'こちらにメールしてください',
            txtSectionIncludeJobIdTitle: 'ジョブ ID を含めてください',
            txtSectionIncludeJobIdBody: 'ジョブを素早く特定するため、ジョブ ID を記載してください。支払い済みの場合は、チェックアウト時のメールアドレスも記載してください。',
            txtSectionBugReportsTitle: 'バグ報告',
            txtSectionBugReportsBody: 'フッターのリンクから、バグ報告や機能リクエストも送信できます。',
        },
        bugReportsFeatures: {
            txtEyebrow: 'フィードバック',
            txtTitle: 'バグ報告と機能リクエスト',
            txtSubtitle: 'UNVOX はまだ初期段階です。違和感がある点やアイデアがあればぜひ送ってください。明確な報告は修正を最速で届ける方法です。',
            txtWhatToIncludeTitle: '含める内容',
            txtChecklistExpectedVsActual: '期待した結果と実際に起きたこと',
            txtChecklistSteps: '再現手順 (1, 2, 3)',
            txtChecklistBrowserOs: '使用ブラウザと OS',
            txtChecklistJobId: 'ジョブ ID（アップロードに関連する場合）',
            txtTipTitle: 'ヒント',
            txtTipBody: 'メールで連絡する場合、受け取った配信メールに直接返信してテンプレートを貼り付けられます。',
            txtTemplateTitle: 'コピペ用テンプレート',
            txtTemplateBody: 'バグ報告 / 機能リクエスト\n\nType: bug | feature\n概要:\n\n詳細:\n- 何が起きたか:\n- 期待していたこと:\n- 再現手順:\n  1.\n- ブラウザ/OS:\n\n任意:\n- ジョブ ID:\n- YouTube URL:\n- スクリーンショット/動画:\n',
            txtTemplatePageLabel: 'ページ',
            txtTemplateUserAgentLabel: 'User agent',
            txtCopyActionIdle: 'テンプレートをコピー',
            txtCopyActionCopied: 'コピーしました',
            txtCopyActionFailed: 'コピーに失敗しました',
            txtCopyHelpFailed: 'クリップボードへのアクセスがブロックされました。上のテキストを選択して手動でコピーできます。',
            txtCopyHelpIdle: 'ここから自動送信はされません。このページは良い報告文の作成を助けるためのものです。',
        },
    },
};
